<p>add-branding-config works!</p>
